import { Box, Divider, TextField } from "@mui/material";
import { Typography } from "@mui/material";




type GnetIdSectionProps = {
  gnetId: string;
  onChange: (value: string) => void;
};


function GnetIdSection(props: GnetIdSectionProps) {
  const { gnetId, onChange } = props;

  return (
    <>
      <Typography variant="h3">Gnet ID</Typography>
      <Box mb={2} mt={1}>
        <Divider />
      </Box>
      <TextField fullWidth label="Gnet ID" value={gnetId} onChange={(e) => onChange(e.target.value)} />
    </>
  );
}

export default GnetIdSection;
